<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 에이지락 미 철회</h2>
      <ul class="rew19_basketAdd_exp">
        <li>철회 하고자 하는 에이지락 미 리워드 프로그램 번호는 {{adr_no}} 입니다.</li>
        <li>결제될 철회 추가금액 및 반환 마일리지를 확인하신 후 철회를 진행해주세요.</li>
      </ul>
      <h3 class="rew19_third_title">세부 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>리워드 번호</em>
          <span class="substance">{{adr_no}}</span>
        </li>
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{$nvl(viewData.pd_detail.ship_name, "-")}}</span>
        </li>

        <template v-if="viewData.pd_detail.payment_typ == AroConst.VALUE_payment_type_credit_card">
          <li class="type1">
            <em>결제방법</em>
            <span class="substance">신용카드</span>
          </li>        
          <li class="type1">
            <em>최종 결제일자</em>
            <span class="substance">{{$nvl(viewData.pd_detail.payment_dt, "-")}}</span>
          </li>
          <li class="type1">
            <em>진행회차</em>
            <span class="substance">
              <span class="rew19_point">{{$nvl(viewData.pd_detail.payment_count, 0)}}</span>회
            </span>
          </li>
        </template>

        <template v-if="viewData.pd_detail.payment_typ == AroConst.VALUE_payment_type_account_transfer">
          <li class="type1">
            <em>전화번호</em>
            <span class="substance">{{$nvl(viewData.pd_detail.ship_tel, "-")}}</span>
          </li>
          <li class="type1">
            <em>핸드폰 번호</em>
            <span class="substance">{{$nvl(viewData.pd_detail.hand_phone, "-")}}</span>
          </li> 
          <li class="type1">
            <em>결제정보</em>
            <span class="substance">자동이체 ({{$nvl(viewData.pd_detail.bank_account, "-")}})</span>
          </li>       
          <li class="type1"
            v-if="viewData.pd_detail.ship_address1 && viewData.pd_detail.ship_address2">
            <em>배송주소</em>
            <span class="substance">{{$nvl(viewData.pd_detail.ship_address1, "")}} {{$nvl(viewData.pd_detail.ship_address2, "")}}</span>
          </li>
          <li v-else class="type1">
            <em>배송주소</em>
            <span class="substance">-</span>
          </li>
          <li class="type1">
            <em>배송일</em>
            <span class="substance">매월 {{$nvl(viewData.pd_detail.delivery_day, "-")}} 일 
              (시작 월: {{$nvl(viewData.pd_detail.start_ym, "-")}})</span>
          </li>
          <li class="type1">
            <em>신청일</em>
            <span class="substance">{{$nvl(viewData.pd_detail.start_date, "-")}}</span>
          </li>
          <li class="type1">
            <em>결제일</em>
            <span class="substance">매월 {{$nvl(viewData.pd_detail.payment_day, "-")}} 일</span>
          </li>
        </template>
      </ul>

      <h3 class="rew19_third_title">정산 내역</h3>

      <div class="rew19_payment_bottom">
        <ul class="rew19_payList">
          <li>
            <em class="rew19_payTitle">에이지락 미 디바이스 할인금액</em>
            <span class="rew19_payDetail">{{$fmt.WON($nvl(viewData.devicepayment_amt,0))}} 원</span>
          </li>
          <li>
            <em class="rew19_payTitle">반환 마일리지</em>
            <span class="rew19_payDetail">{{$fmt.PV($nvl(viewData.mileage.adrPointTotal,"0.00"))}}</span>
          </li>
          <li>
            <em class="rew19_payTitle">현재 보유 마일리지</em>
            <span class="rew19_payDetail">{{$fmt.PV($nvl(viewData.mileage.availablePoints,"0.00"))}}</span>
            <ul class="rew19_dotList">
              <li>마일리지 사용으로 인해, 반환 마일리지가 보유 마일리지보다 클 경우 차액은 금액으로 환산하여 청구됩니다.</li>
              <li class="rew19_point">(1마일리지 = 1,442원)</li>
            </ul>
          </li>
          <li class="lastLine">
            <em class="rew19_payTitle">마일리지 차액 환산 금액</em>
            <span class="rew19_payDetail">{{$fmt.WON($nvl(viewData.mileage.priceOwed,0))}} 원</span>
          </li>
          <li class="lastLine">
            <em class="rew19_payTitle">
              최종 추가결제 금액
              <br />(디바이스 할인금액 + 반환 마일리지)
            </em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON($nvl(viewData.addpayment_amt,0))}} 원</strong>
            </span>
          </li>
        </ul>
      </div>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickCancel" class="rew19-btn-border">취소</a>
        <a v-if="viewData.addpayment_amt <= 0"
          @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>        
        <a v-else 
          @click="onClickNextProcess" class="rew19-btn-normal">다음</a>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "AgelocWithdraw",
  extends: AroBase,
  components: { }, 
  props:{
    adr_no: {
      type: String,
      required: true
    },    
  },
  data() { 
    return {     
      //View Data 

      viewData : {
        mileage : {},
        pd_detail: {}
      },      
    }
  },
  created() {
  },
  mounted() {
    let _this = this;
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },
    
    /**
     * Local function
     */
    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };
    },

    //취소
    onClickCancel(){
      this.$emit('cancel');
    },

    //철회 하기
    onClickWithdraw(){
      let _this = this;

      let payment_type = _this.viewData.pd_detail.payment_typ;
      let additionalData = {};
      if(_this.AroConst.VALUE_payment_type_credit_card == payment_type){
        additionalData = {
          ExpDateY : _this.viewData.pd_detail.ExpDateY,
		      ExpDateM : _this.viewData.pd_detail.ExpDateM,
		      CardNumber : _this.viewData.pd_detail.CardNumber
        }; 
      }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_type){
        additionalData = {}; //추가데이터 없음
      }else{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return;
      }      

      _this.$emit('doWithdraw', payment_type, additionalData);
    },

    //다음 진행
    onClickNextProcess(){
      this.$emit('nextProcess');      
    },
  }
}
</script>
<style>
a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/withdrawInfo.vue